import React from "react"
import { useTranslation } from "react-i18next"

import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"
import { VideoWrapper } from "~/components/VideoWrapper/VideoWrapper"

import styles from "./index.module.css"

export const Hero: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Theme className={styles.Wrapper} theme="dark">
      <VideoWrapper defaultVideo="videoTwo" loop />

      <div className="container">
        <Breadcrumbs />

        <div className="grid grid--col-12">
          <div className={styles.Head}>
            <Heading className={styles.Title} like="h1">
              <Raw html={t("indexes-and-ratings.Hero.Title")} />
            </Heading>

            <div>
              <Raw html={t("indexes-and-ratings.Hero.Text")} />
            </div>
          </div>
        </div>
      </div>
    </Theme>
  )
}
